// Local SEO landing pages: cities we serve across Loudoun & neighboring counties.
// Each entry produces a dedicated page at /dentist-in-:slug with unique
// meta, copy, and LocalBusiness / Place schema.

export const LOCAL_AREAS = [
  {
    slug: "leesburg-va",
    city: "Leesburg",
    state: "VA",
    tagline: "Our home town.",
    distance: "Downtown Leesburg — we're on Harrison Street SE",
    zip: ["20175", "20176", "20177"],
    neighborhoods: ["Historic District", "Exeter", "Beacon Hill", "Lansdowne", "Potomac Station"],
    intro:
      "Smiles of Loudoun has cared for Leesburg families since our doors opened. Our office sits in the historic downtown on Harrison Street SE — walk-in friendly, easy parking, and a warm family feel our neighbors know by name.",
    highlights: [
      "Cleanings, cosmetic care, implants and sedation — all under one roof",
      "Bilingual team: English, Spanish, French and Farsi",
      "In-network with most PPO plans your Leesburg employer offers",
      "Emergency dentistry with same-day appointments",
    ],
    landmarks: [
      "Walking distance from Leesburg Town Green",
      "5 minutes from Village at Leesburg",
      "Easy access via Route 15 and the Leesburg Bypass",
    ],
    featuredServices: [
      "dental-cleanings-exams",
      "invisalign",
      "porcelain-veneers",
      "dental-implants",
      "teeth-whitening",
      "iv-sedation",
    ],
  },
  {
    slug: "ashburn-va",
    city: "Ashburn",
    state: "VA",
    tagline: "A short drive east on Route 7.",
    distance: "About 8 minutes east on Route 7",
    zip: ["20147", "20148"],
    neighborhoods: ["Broadlands", "Brambleton", "Loudoun Valley Estates", "Ashburn Farm"],
    intro:
      "Ashburn families have trusted Smiles of Loudoun for gentle family dentistry, cosmetic care, and dental implants for years. Our Leesburg office is a short drive east on Route 7 with easy parking and evening appointments — no traffic through Dulles required.",
    highlights: [
      "Same-week new patient visits for Ashburn families",
      "Bilingual team: English, Spanish, French and Farsi",
      "In-network with most PPO plans your Ashburn employer offers",
      "IV sedation available for anxious patients",
    ],
    landmarks: [
      "5 minutes from One Loudoun",
      "10 minutes from Ashburn Metro Station",
      "Convenient to Broadlands and Brambleton residents",
    ],
    featuredServices: [
      "invisalign",
      "porcelain-veneers",
      "dental-implants",
      "teeth-whitening",
      "dental-cleanings-exams",
      "iv-sedation",
    ],
  },
  {
    slug: "broadlands-va",
    city: "Broadlands",
    state: "VA",
    tagline: "Just up Belmont Ridge Road.",
    distance: "About 12 minutes from Broadlands, off Ryan Road",
    zip: ["20148"],
    neighborhoods: ["Southern Walk", "Broadlands South", "Woods at Broadlands"],
    intro:
      "Smiles of Loudoun is proud to serve Broadlands residents with warm, personalized dental care. From your first cleaning to a full smile makeover, our Leesburg team is just a short drive up Belmont Ridge Road — with the calm, unhurried atmosphere Broadlands families love.",
    highlights: [
      "Family cleanings, exams and Invisalign — all under one roof",
      "Membership plan for patients without insurance",
      "Emergency same-day appointments when you need them",
      "$129 new patient special: exam, X-rays and cleaning",
    ],
    landmarks: [
      "8 minutes from Nature House at Claude Moore Park",
      "10 minutes from Broadlands Community Center",
      "Easy access via Belmont Ridge Road",
    ],
    featuredServices: [
      "invisalign",
      "dental-implants",
      "cosmetic-gum-contouring",
      "porcelain-veneers",
      "night-guards",
      "tmj-treatment",
    ],
  },
  {
    slug: "belmont-va",
    city: "Belmont",
    state: "VA",
    tagline: "Boutique dentistry, Belmont-quiet.",
    distance: "About 10 minutes from Belmont Country Club",
    zip: ["20176", "20117"],
    neighborhoods: ["Belmont Country Club", "Belmont Chase", "Belmont Greene"],
    intro:
      "Belmont residents deserve dentistry that respects their time and their taste. At Smiles of Loudoun, Drs. Yopa, Ide Noumy and Ebrahimi combine advanced training in cosmetic and implant dentistry with the quiet, boutique feel our Belmont neighbors appreciate — just up the road in downtown Leesburg.",
    highlights: [
      "Cosmetic veneers and full-arch implant restoration",
      "BOTOX® and JUVÉDERM® for facial harmony",
      "Concierge-level scheduling with minimal wait time",
      "IV and oral sedation for a truly relaxed visit",
    ],
    landmarks: [
      "12 minutes from Belmont Country Club",
      "8 minutes from Belmont Chase shopping",
      "Direct route via Route 7 west",
    ],
    featuredServices: [
      "porcelain-veneers",
      "dental-implants",
      "cosmetic-gum-contouring",
      "teeth-whitening",
      "iv-sedation",
      "dental-crowns",
    ],
  },
  {
    slug: "purcellville-va",
    city: "Purcellville",
    state: "VA",
    tagline: "Small town care, city-caliber training.",
    distance: "About 20 minutes west on Route 7",
    zip: ["20132"],
    neighborhoods: ["Mayfair", "Wright Farm", "Locust Grove"],
    intro:
      "Purcellville families have trusted our team for generational dental care. Whether it's a child's first cleaning or grandpa's implant restoration, our Leesburg office brings the technology and specialists Purcellville can count on — with the neighborly manners of Western Loudoun.",
    highlights: [
      "Full-family scheduling — kids and grandparents same visit",
      "Sedation options for anxious or complex cases",
      "In-office implant placement and restoration",
      "Bilingual team: English, Spanish, French and Farsi",
    ],
    landmarks: [
      "20 minutes east on Route 7",
      "Convenient after school pickup or errands in Leesburg",
      "Free, safe parking at our downtown office",
    ],
    featuredServices: [
      "dental-cleanings-exams",
      "dental-implants",
      "emergency-dentistry",
      "root-canal-therapy",
      "dentures",
      "oral-conscious-sedation",
    ],
  },
  {
    slug: "middleburg-va",
    city: "Middleburg",
    state: "VA",
    tagline: "Discretion, quality, hunt-country calm.",
    distance: "About 25 minutes south via Route 15 and Route 50",
    zip: ["20117"],
    neighborhoods: ["Salamander area", "Foxcroft", "Ashby"],
    intro:
      "For Middleburg residents who value discretion and craftsmanship, Smiles of Loudoun offers the boutique cosmetic and implant dentistry you'd expect — with the added benefit of Dr. Yopa's NYU-trained implantology and Harvard-honed oral surgery credentials. We build long-standing relationships with our hunt-country clientele.",
    highlights: [
      "Cosmetic veneers, whitening and smile design",
      "Full-arch implant restoration",
      "BOTOX® and JUVÉDERM® in the same trusted office",
      "Private consultations by appointment",
    ],
    landmarks: [
      "25 minutes north via Route 15",
      "Convenient for combined Leesburg outings",
      "Off-street parking at our historic downtown office",
    ],
    featuredServices: [
      "porcelain-veneers",
      "teeth-whitening",
      "dental-implants",
      "cosmetic-gum-contouring",
      "dental-crowns",
      "iv-sedation",
    ],
  },
  {
    slug: "waterford-va",
    city: "Waterford",
    state: "VA",
    tagline: "Historic Waterford's neighborhood dentist.",
    distance: "About 15 minutes north of downtown Leesburg",
    zip: ["20197"],
    neighborhoods: ["Waterford Village", "Old Ridge"],
    intro:
      "Waterford is one of Loudoun's most cherished historic villages, and our team is honored to serve neighbors who value tradition and quality. Our Leesburg office is a short, scenic drive south — with modern digital dentistry housed in a warm, unhurried practice.",
    highlights: [
      "Preventive family dentistry for every generation",
      "Digital X-rays and same-day crowns",
      "IV and oral sedation for anxious visits",
      "Emergency dentistry with same-day appointments",
    ],
    landmarks: [
      "15 minutes south on Route 662",
      "Easy stop after Leesburg errands",
      "Direct route via Old Waterford Road",
    ],
    featuredServices: [
      "dental-cleanings-exams",
      "composite-fillings",
      "dental-crowns",
      "dental-implants",
      "emergency-dentistry",
      "night-guards",
    ],
  },
  {
    slug: "herndon-va",
    city: "Herndon",
    state: "VA",
    tagline: "West of Herndon, worth the short drive.",
    distance: "About 20 minutes northwest via the Dulles Toll Road / Route 7",
    zip: ["20170", "20171", "20172"],
    neighborhoods: ["Downtown Herndon", "Chantilly Highlands", "McNair Farms"],
    intro:
      "For Herndon families and professionals seeking bilingual, boutique dental care, Smiles of Loudoun is a short trip northwest on Route 7. We're a favorite for patients who want cosmetic and implant expertise without commuting into DC — with the added bonus of easy parking.",
    highlights: [
      "Bilingual team: English, Spanish, French and Farsi",
      "Cosmetic veneers, Invisalign and implants",
      "Full sedation menu including IV",
      "Evening appointments to fit your commute",
    ],
    landmarks: [
      "20 minutes via Route 7 west",
      "Easy access from the Dulles Toll Road",
      "Convenient for Reston Town Center commuters",
    ],
    featuredServices: [
      "invisalign",
      "porcelain-veneers",
      "dental-implants",
      "teeth-whitening",
      "iv-sedation",
      "root-canal-therapy",
    ],
  },
  {
    slug: "dulles-va",
    city: "Dulles",
    state: "VA",
    tagline: "Between flights, between meetings — we make it easy.",
    distance: "About 15 minutes via Route 28 and Route 7",
    zip: ["20166"],
    neighborhoods: ["Dulles South", "South Riding-adjacent", "Kirkpatrick Farms"],
    intro:
      "Dulles-area residents and travelers count on Smiles of Loudoun for dental care that fits a busy life. Our efficient scheduling and boutique approach mean less time in the chair and more time back to what matters — whether that's boarding a flight or getting home to family.",
    highlights: [
      "Same-week appointments and quick concierge scheduling",
      "Emergency dentistry with same-day slots",
      "Sedation dentistry for a stress-free visit",
      "In-network with most PPO plans",
    ],
    landmarks: [
      "15 minutes via Route 28 north",
      "Convenient for Dulles Airport travelers",
      "Free parking at our downtown Leesburg office",
    ],
    featuredServices: [
      "emergency-dentistry",
      "dental-cleanings-exams",
      "invisalign",
      "dental-implants",
      "teeth-whitening",
      "iv-sedation",
    ],
  },
  {
    slug: "reston-va",
    city: "Reston",
    state: "VA",
    tagline: "Reston-quality dentistry, Loudoun-quiet setting.",
    distance: "About 25 minutes northwest via Route 7",
    zip: ["20190", "20191", "20194"],
    neighborhoods: ["Reston Town Center", "North Point", "South Lakes"],
    intro:
      "Reston residents who want boutique dentistry — without the Reston Town Center traffic — make the short trip up Route 7 to Smiles of Loudoun. Our team pairs advanced cosmetic and implant training with the calm, unhurried atmosphere that makes appointments feel less clinical and more human.",
    highlights: [
      "Cosmetic veneers, Invisalign and whitening",
      "Full-arch implant restoration",
      "BOTOX® and JUVÉDERM® under the same roof",
      "Bilingual team: English, Spanish, French and Farsi",
    ],
    landmarks: [
      "25 minutes northwest on Route 7",
      "Easy Saturday combo with a Leesburg wine day",
      "Free downtown parking at our office",
    ],
    featuredServices: [
      "porcelain-veneers",
      "invisalign",
      "dental-implants",
      "teeth-whitening",
      "cosmetic-gum-contouring",
      "iv-sedation",
    ],
  },
  {
    slug: "sterling-va",
    city: "Sterling",
    state: "VA",
    tagline: "A quick trip up Route 7 for care worth the drive.",
    distance: "About 15 minutes northwest via Route 7",
    zip: ["20164", "20165", "20166"],
    neighborhoods: ["Sugarland Run", "Countryside", "Cascades"],
    intro:
      "Sterling families rely on Smiles of Loudoun for gentle, honest dentistry — from routine cleanings to complex smile makeovers. Our Leesburg office is a straight shot up Route 7, and we make the drive worth it with same-day crowns, digital dentistry, and a bilingual team who knows your family by name.",
    highlights: [
      "Same-day crowns and digital dentistry",
      "Family cleanings, exams and Invisalign",
      "Bilingual team: English, Spanish, French and Farsi",
      "Membership plan for patients without insurance",
    ],
    landmarks: [
      "15 minutes via Route 7 west",
      "Easy access from Sugarland Run and Cascades",
      "Free downtown Leesburg parking",
    ],
    featuredServices: [
      "dental-cleanings-exams",
      "dental-crowns",
      "invisalign",
      "dental-implants",
      "composite-fillings",
      "night-guards",
    ],
  },
];

export function findAreaBySlug(slug) {
  return LOCAL_AREAS.find((a) => a.slug === slug);
}
